import { render } from "./forget.vue?vue&type=template&id=32ca3d9e&scoped=true"
import script from "./forget.vue?vue&type=script&lang=js"
export * from "./forget.vue?vue&type=script&lang=js"

import "./forget.vue?vue&type=style&index=0&id=32ca3d9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ca3d9e"]])

export default __exports__